import { Chip } from "@mui/material";
import { PRO_INDIGO } from "../colors";

export const ProPill = () => (
  <Chip
    label="PRO"
    size="small"
    style={{
      backgroundColor: PRO_INDIGO,
      color: "#FFFFFF",
      fontWeight: 800,
      fontSize: 11,
      height: 20,
      letterSpacing: "0.05em",
    }}
  />
);

export default ProPill;
